import { render, staticRenderFns } from "./navigate-left-change.vue?vue&type=template&id=27e47ae6&scoped=true&"
import script from "./navigate-left-change.vue?vue&type=script&lang=js&"
export * from "./navigate-left-change.vue?vue&type=script&lang=js&"
import style0 from "./navigate-left-change.vue?vue&type=style&index=0&id=27e47ae6&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e47ae6",
  null
  
)

export default component.exports